import React from "react";

import { Grid } from "@material-ui/core";

import {
  Labeled,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { useUser } from "../../../authenticatorApp/UserContext";
import { BackButton } from "../../../components/common/BackButton";
import { CarrierAside } from "./CarrierUserAside";
import { CarrierUserYardAccess } from "./CarrierUserYardAccess";

// Read-only: a user who may manage colleagues edits them on CarrierEdit, which
// is where changing and removing their access lives.
const UserShowActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

const UserShowGrid = ({ record, ...props }) => {
  const { appUser } = useUser();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Labeled label="Firs Name">
          <TextField source="firstName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Last Name">
          <TextField source="lastName" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Email">
          <TextField source="email" />
        </Labeled>
      </Grid>
      <Grid item xs={12} md={6}>
        <Labeled label="Phone">
          <TextField source="phone" />
        </Labeled>
      </Grid>
      {/* The same report the editable profile carries: where this person stands
          at each transload, and where one has taken their access away. */}
      <CarrierUserYardAccess
        record={record}
        appUser={appUser}
        isSelf={record?.id === appUser?.id}
      />
    </Grid>
  );
};

export const CarrierShow = (props) => {
  return (
    <Show
      {...props}
      title="View User"
      actions={<UserShowActions />}
      aside={<CarrierAside {...props} />}
    >
      <SimpleShowLayout>
        <UserShowGrid />
      </SimpleShowLayout>
    </Show>
  );
};
